module.exports = __webpack_public_path__ + "static/img/5.6c61b97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/5.png
// module id = JfEi
// module chunks = 0